import styled from '@emotion/styled';
import { scrollbarStyles } from 'common/styledComponents/mixins';
import { Text } from 'common/styledComponents/typography';

const Container = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
`;

const P = styled(Text)`
  margin: ${({ theme }) => theme.space(2.5, 0, 1.5, 0)};
  opacity: 0.75;
`;

const Form = styled.form`
  margin: ${({ theme }) => theme.space(4, 0, 0)};
  &[aria-busy='true'] {
    opacity: 0.72;
    pointer-events: none;
  }
`;

const SelectAllWrapper = styled.div`
  margin: ${({ theme }) => theme.space(2, 0)};
  cursor: pointer;
`;

const FooterActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  border-top: 1px solid ${({ theme }) => theme.colors.gray100.toString()};
  justify-content: flex-end;
  padding-top: ${({ theme }) => theme.space(1.5)};
`;

const CheckboxListGroupWrapper = styled.div`
  flex: 1 1 auto;
  padding-right: ${({ theme }) => theme.space(0.5)};

  // Apply the scrollbar styles
  ${scrollbarStyles()}
`;

const ErrorsContainer = styled.div`
  padding: ${({ theme }) => theme.space(2, 0)};
`;

export { Container, P, Form, SelectAllWrapper, FooterActionsWrapper, CheckboxListGroupWrapper, ErrorsContainer };
